import imageSrc from "../../../assets/svg/files/icon-file-image-1.svg";
import pdfSrc from "../../../assets/svg/files/icon-file-pdf.svg";
import textSrc from "../../../assets/svg/files/icon-file-text.svg";
import videoSrc from "../../../assets/svg/files/icon-file-movie.svg";
import excelSrc from "../../../assets/svg/files/icons-microsoft-excel-logos.svg";
import powerpointSrc from "../../../assets/svg/files/icons-microsoft-powerpoint-logos.svg";
import wordSrc from "../../../assets/svg/files/icons-microsoft-word-logos.svg";
import blankSrc from "../../../assets/svg/files/icon-file-blank.svg";
import emailSrc from "../../../assets/svg/outlook.svg";

export const FileIconPresentational = ({ extension, className }: { extension?: string | null; className: string }) => {
  switch (extension?.toLowerCase()) {
    case ".png":
    case ".jpg":
    case ".jpeg":
      return <img className={className} alt="image file" src={imageSrc} />;
    case ".wav":
    case ".mp4":
      return <img className={className} alt="video" src={videoSrc} />;
    case ".docx":
    case ".doc":
      return <img className={className} alt="microsoft word" src={wordSrc} />;
    case ".csv":
    case ".xlsx":
    case ".xls":
      return <img className={className} alt="microsoft excel" src={excelSrc} />;
    case ".ppt":
      return <img className={className} alt="microsoft powerpoint" src={powerpointSrc} />;
    case ".txt":
      return <img className={className} alt="text file" src={textSrc} />;
    case ".pdf":
      return <img className={className} alt="PDF" src={pdfSrc} />;
    case ".eml":
    case ".msg":
      return <img className={className} alt="Email" src={emailSrc} />;
    default:
      return <img className={className} alt="Unknown type" src={blankSrc} />;
  }
};
